'use client';

import gtm from '@/utils/gtm';
import { saveAICookieForShopify, saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import EcoStat from 'eco-design-micro/EcoStat';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

const uaEventName = 'uaEvent';
export default function Link({ href, className, stopPropagation = false, dataLayer = null, onClick, children, ...rest }: any) {
    const isNoneHttp = (href || '').indexOf('http') === -1;
    const isIncudesWebsite = (href || '').indexOf('www.ecoflow.com') > -1;
    const isWebsite = isNoneHttp || isIncudesWebsite;
    const { locale = 'us' } = useRouter();
    // 触发埋点
    const handleGTM = (params: any) => {
        if (Array.isArray(params)) {
            params.forEach((v) => gtm.push(v));
        } else if (params) {
            gtm.push({
                event: uaEventName,
                __is_shopify_href: (href || '').includes(`${locale}.ecoflow.com`),
                ...params,
            });
        }
    };
    // 点击事件
    const clickHandle = (e: any) => {
        if (stopPropagation) {
            e.stopPropagation();
        }
        saveCookieForShopify(href, locale);
        saveAICookieForShopify(href, locale);
        dataLayer && handleGTM(dataLayer);
        onClick && onClick(); //触发回调
        // 记录用户下一个页面
        EcoStat.leavePageFromPathname(href);
    };
    return (
        <a
            className={`${styles.lowcodelink} editor-link ${className ? ` ${className}` : ''}`}
            href={href}
            target={isWebsite ? '_self' : '_blank'}
            rel="noreferrer"
            onClick={clickHandle}
            {...rest}
        >
            {children}
        </a>
    );
}
